<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="ded">For Pamela Anne Lael I love you, little sister.</a></p><a id="ded">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?2eed8e5d